import { render, staticRenderFns } from "./q6.vue?vue&type=template&id=71468afe&"
import script from "./q6.vue?vue&type=script&lang=js&"
export * from "./q6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports